import VueRouter from 'vue-router'

import PcMain from '@/pcViews/Main.vue'
import HsqWelcome from '@/pcViews/HsqWelcome.vue'
import { commonParams } from '@/libs/commonParamsStore.js'

const routes = [
  { path: '/welcome',name:'welcome', component: HsqWelcome },
  { path: '*',name:'login', component: PcMain }
]

let router =  new VueRouter({
  mode: 'history',
  routes // (缩写) 相当于 routes: routes
})
router.afterEach(() => {
  commonParams.initSys()
})
export default router